import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";

@Injectable()
export class ToastProvider {
  constructor(public toastCtrl: ToastController) {}

  success(message: string, duration?: number): void {
    this.show("success", message, duration);
  }

  complete(message: string, callback?: Function): void {
    this.show("square-toast", message, 1500, "middle", callback);
  }

  completeCheckToast(message: string, callback?: Function): void {
    this.show("square-check-toast", message, 1500, "middle", callback);
  }

  cancel(): void {
    this.show("square-toast", null);
  }

  create(options: any, callback?: Function): void {
    this.show(
      options.cssClass,
      options.message,
      options.duration,
      options.position,
      callback
    );
  }

  private show(
    type: string,
    message: string,
    duration?: number,
    position?: string,
    callback?: Function
  ): void {
    duration = duration || 3000;
    const toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position || "top",
      cssClass: type,
    });
    if (callback) {
      toast.onDidDismiss(() => callback());
    }
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/toast/toast.ts